import http from '../interceptors/Intercepter';

export const viewAllSecurityQuestions = async (username) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.get('/api/security-question/viewAll', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const createSecurityQuestion = async (createSecurityQuestionsRequest) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = await http.post('/api/security-question/create', createSecurityQuestionsRequest, { ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
